export const getFirstAnalysesData = state => state.firstAnalyses.all;
export const getFirstAnalysisData = state => state.firstAnalyses.firstAnalysis;
export const firstAnalysesIsFetching = state => state.firstAnalyses.loading.all;
export const firstAnalysisIsFetching = state => state.firstAnalyses.loading.firstAnalysis;